import React, { FC, useState } from "react";
import styled from "styled-components";
import {
  Avatar,
  Col,
  Row,
  Space,
  Spin,
  Typography,
  Modal,
  notification,
  Image,
} from "antd";
import HeaderComponent from "../../Components/HeaderComponents";
import { ExpertText, HeaderTitle, SmallText } from "../../Components/Text3D";
import { BoxQ } from "../../Components/Box3D";
import { MediumHeaderTitle } from "../../Components/Text3D";
import FooterPublic3D from "../../Components/FooterPublic3D";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_DESIGNS, GET_SINGLE_DESIGN } from "../../Apollo/graphql/Query";
import { useHistory, useParams } from "react-router-dom";
import Img3D from "../../Components/Model3D";
import CommentIcon from "../../assets/images/comment1.png";
import { ContainerBtn } from "../../Components/Button3D";
import Comments from "../../Components/Comments";
import { useStoreActions, useStoreState } from "../../myStore";
import MyCard from "../../Components/MyCard";
import { getUserData, getCookies } from "../../utils/utilsFunctions";
import { BUY_DESIGN } from "../../Apollo/graphql/Mutation/BuyDesign";
import { RATE_MUTATION } from "../../Apollo/graphql/Mutation/RateMutation";
import { DOWNLOAD_DESIGN_V2 } from "../../Apollo/graphql/Mutation/DownloadDesign";
import {
  HiOutlineThumbUp,
  HiOutlineThumbDown,
  HiThumbUp,
  HiThumbDown,
} from "react-icons/hi";
import { replaceError } from "../../utils/utilsFunctions";

const MainWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background: white;
`;
const SideContainter = styled.div`
  background-color: #f7f7f7;
  padding: 2rem 4rem 2rem 2rem;
  width: 100%;
`;
const LikeCommentDiv = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 2rem 0;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0;
  }
`;
const IconSection = styled.div`
  display: flex;
  /* align-self: flex-start; */
  cursor: pointer;
  @media screen and (max-width: 768px) {
    padding-bottom: 1rem;
  }
`;
export const IconDiv = styled(Col)`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
`;
const UserSection = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
`;
const TextSpan = styled(Col)`
  background-color: #f7f7f7;
  height: 100%;
  flex-direction: column;
  padding: 0.2rem 1rem;
  min-height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
`;
const Section = styled(Col)`
  display: flex;
  margin: 1.5rem auto;
`;
const SmallContentContainer = styled.div`
  display: flex;
  font-family: "Rogan";
  height: 100%;
  flex-direction: column;
  background-color: rgb(247, 247, 247);
  justify-content: center;
  padding: 0.2rem 1rem;
`;
const image3dStyle = {
  top: 0,
  right: 0,
  alignItems: "center",
  height: "500px",
  width: "500px",
};
const SmallTextA = styled(SmallText)`
  font-size: 1rem;
`;

const LicenseWrapper = styled.div`
  .license-images {
    display: flex;
    flex-direction: row;
    div {
      margin-right: 4px;
    }
  }
`;

const SingleDesignPage: FC = () => {
  const { id } = useParams<{ id?: string }>();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentProcessTitle, setCurrentProcessTitle] = useState<any>(null);

  const history = useHistory();
  const loginUser = !!getCookies() && !!getUserData();
  const user = JSON.parse(getUserData("user"));

  const currentItem = useStoreState((state: any) => state.cart.currentItem);
  const setCurrentItem = useStoreActions(
    (actions: any) => actions.cart.setCurrentItem
  );

  const [buyDesignMutation] = useMutation(BUY_DESIGN);
  const [downloadDesignMutation] = useMutation(DOWNLOAD_DESIGN_V2);
  const [rateDesignMutation, { loading: designLoading }] =
    useMutation(RATE_MUTATION);

  const onHandleClick = () => {
    let items = currentItem;
    items.push({
      designUrl: data?.design?.design,
      designId: id,
      marketPlaceType: data?.design?.marketPlaceType,
      designDescription: data?.design?.description,
      designName: data?.design?.name,
    });
    setCurrentItem(items);
    history.push("/design/quantity");
  };

  const { data: designsData, refetch } = useQuery(GET_ALL_DESIGNS, {
    variables: {
      pagination: {
        page: 1,
        limit: 3,
      },
    },
  });

  const {
    data,
    loading: DesignLoading,
    error,
  } = useQuery(GET_SINGLE_DESIGN, {
    variables: {
      designId: id,
    },
  });

  if (error) {
    return <div>Something went wront.</div>;
  }
  const onLikeClick = async () => {
    if (!loginUser) {
      notification.error({
        message: "Error",
        description: "Please login first",
      });
    } else {
      try {
        await rateDesignMutation({
          variables: {
            input: {
              type: "likeDislike",
              resourceType: "design",
              sentiment: "positive",
              resourceId: id,
            },
          },
        });
        refetch();
      } catch (e) {
        console.log("Error", e);
      }
    }
  };
  const onDisLikeClick = async () => {
    if (!loginUser) {
      notification.error({
        message: "Error",
        description: "Please login first",
      });
    } else {
      try {
        await rateDesignMutation({
          variables: {
            input: {
              type: "likeDislike",
              resourceType: "design",
              sentiment: "negative",
              resourceId: id,
            },
          },
        });
        refetch();
      } catch (e) {
        console.log("Error", e);
      }
    }
  };
  const onDownloadClick = async (design: any) => {
    try {
      if (!loginUser) {
        notification.error({
          message: "Login Required",
          description: "Please login to download the file",
        });
        return;
      }
      setLoading(true);
      setCurrentProcessTitle("File Downloading...");
      const {
        data: { downloadDesignV2: presignedUrls },
      }: any = await downloadDesignMutation({
        variables: { designId: id },
      });

      if (presignedUrls) {
        // eslint-disable-next-line array-callback-return
        presignedUrls.map((url, index) => {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${id}_${index}.stl`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      }
      setLoading(false);
      setCurrentProcessTitle("");
      notification.success({
        message: "Downloading ...",
        description:
          "Your download has started, check your downloads in browser",
      });
    } catch (err) {
      setLoading(false);
      setCurrentProcessTitle("");
      notification.error({
        message: "Error",
        description: replaceError(err),
      });
    }
  };

  const handleOk = () => {
    buyDesignMutation({
      variables: {
        designId: id,
      },
    })
      .then((res) => {
        window.location.replace(res.data.buyDesign.url);
      })
      .catch((err) => {
        notification.error({
          message: "Errpr",
          description: err.message || "",
        });
      });
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const hasLiked =
    user &&
    data &&
    data.design?.likedBy &&
    data.design?.likedBy.find(
      (l) => l.ratedByUserId.toString() === user._id.toString()
    );
  const hasDisLiked =
    data &&
    data.design?.disLikedBy &&
    data.design?.disLikedBy.find(
      (l) => l.ratedByUserId.toString() === user._id.toString()
    );

  return (
    <Spin
      spinning={loading || DesignLoading || designLoading}
      tip={currentProcessTitle}
    >
      <MainWrapper>
        <HeaderComponent bg="white" />
        <div style={{ padding: "0 0.5rem" }}>
          <Modal
            title={`Do you want to download this design for $${data?.design?.price} ?`}
            visible={isModalVisible}
            okText="Buy Now"
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <p>
              Note: If you have already paid for this design, cancel this and
              please check the order status from orders page.
            </p>
          </Modal>
          <Col
            xl={{ span: 20, offset: 2 }}
            lg={{ span: 22, offset: 1 }}
            sm={{ span: 22, offset: 1 }}
          >
            <Row
              style={{
                marginTop: "4rem",
                width: "100%",
                background: "#999999",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Col
                xl={{ span: 14 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                style={{ minHeight: "100%" }}
              >
                <Space
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {data?.design?.design?.endsWith(".stl") ? (
                    <Img3D url={data?.design.design} style={image3dStyle} />
                  ) : (
                    <img src={data?.design.design} alt="" />
                  )}
                </Space>
              </Col>
              <Col
                xl={{ span: 10 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                style={{ height: "100%", width: "100%" }}
              >
                <SideContainter>
                  <MediumHeaderTitle dark fontSize>
                    {data?.design?.name || ""}
                  </MediumHeaderTitle>
                  <Typography>{data?.design?.description || ""}</Typography>
                  <LikeCommentDiv>
                    <IconSection onClick={onLikeClick}>
                      <>
                        {hasLiked ? (
                          <HiThumbUp
                            style={{ marginRight: ".5rem", fontSize: "1.5rem" }}
                          />
                        ) : (
                          <HiOutlineThumbUp
                            style={{ marginRight: ".5rem", fontSize: "1.5rem" }}
                          />
                        )}

                        <SmallTextA>
                          {data?.design?.totalLikes || 0} LIKES
                        </SmallTextA>
                      </>
                    </IconSection>
                    <IconSection onClick={onDisLikeClick}>
                      <>
                        {hasDisLiked ? (
                          <HiThumbDown
                            style={{ fontSize: "1.5rem", marginRight: ".5rem" }}
                          />
                        ) : (
                          <HiOutlineThumbDown
                            style={{ fontSize: "1.5rem", marginRight: ".5rem" }}
                          />
                        )}

                        <SmallTextA>
                          {data?.design?.totalDisLikes || 0} DISLIKES
                        </SmallTextA>
                      </>
                    </IconSection>
                    <a href="#comments">
                      <IconSection>
                        <img
                          src={CommentIcon}
                          alt=""
                          height="20px"
                          style={{ marginRight: ".5rem" }}
                        />
                        <SmallTextA>
                          {data?.design?.commentCount || 0} COMMENTS
                        </SmallTextA>
                      </IconSection>
                    </a>
                  </LikeCommentDiv>
                  <hr style={{ border: "1px solid #D8D8D8" }} />
                  <ContainerBtn
                    type="primary"
                    style={{ marginTop: "2rem" }}
                    onClick={() => onDownloadClick(data)}
                  >
                    {`Download File (${
                      data?.design.marketPlaceType === "Paid"
                        ? data?.design?.desingPrice
                        : data?.design.marketPlaceType
                    })`}
                  </ContainerBtn>
                  <ContainerBtn
                    type="primary"
                    style={{ background: "#09B94F", margin: "2rem 0" }}
                    onClick={onHandleClick}
                  >
                    Print this
                  </ContainerBtn>
                  <hr style={{ border: "1px solid #D8D8D8" }} />
                  <UserSection>
                    <Avatar
                      style={{
                        color: "#1196DD",
                        background: "#fff",
                        border: "1px solid #D8D8D8",
                      }}
                    >
                      A
                    </Avatar>
                    <Typography
                      style={{ color: "#1196DD", marginLeft: "2rem" }}
                    >
                      {data?.design?.name}
                    </Typography>
                  </UserSection>
                </SideContainter>
                {/* </Space> */}
              </Col>
            </Row>
            <Row
              style={{ width: "100%", display: "flex", marginTop: "2rem" }}
              gutter={[20, 20]}
              wrap
            >
              <Col md={8} xs={24}>
                <TextSpan>
                  <SmallText>{data?.design?.name}</SmallText>
                </TextSpan>
              </Col>
              <Col md={4} xs={24}>
                <SmallContentContainer>
                  <SmallText>{data?.design?.commentCount || 0}</SmallText>
                  <Typography>Comments</Typography>
                </SmallContentContainer>
              </Col>
              <Col md={4} xs={24}>
                <SmallContentContainer>
                  <SmallText>{data?.design?.downloadsCount || 0}</SmallText>
                  <Typography>Times Downloaded</Typography>
                </SmallContentContainer>
              </Col>
              <Col md={4} xs={24}>
                <SmallContentContainer>
                  <SmallText>{data?.design?.printCount || 0}</SmallText>
                  <Typography>Times Printed</Typography>
                </SmallContentContainer>
              </Col>
              <Col md={4} xs={24}>
                <SmallContentContainer>
                  <SmallText>{data?.design?.images.length || 0}</SmallText>
                  <Typography>Files</Typography>
                </SmallContentContainer>
              </Col>
            </Row>
            <Row
              style={{ marginTop: "2rem", width: "100%" }}
              gutter={{ xs: 0, md: 24 }}
            >
              <Col md={6} xs={24}>
                { data && data.design && data.design.marketPlaceType !== 'PRIVATE' && (
                  <LicenseWrapper
                  style={{
                    padding: ".5rem 1rem",
                    background: "rgb(247, 247, 247)",
                  }}
                >
                  <SmallText
                    style={{ paddingTop: "1.5rem", paddingBottom: ".5rem" }}
                  >
                    License
                  </SmallText>
                  <div className="license-images">
                    <div>
                      <Image src="https://threedmake.s3.ap-southeast-2.amazonaws.com/assets/creativecommons.svg" width={36} preview={false} />
                    </div>
                    <div>
                    <Image src="https://threedmake.s3.ap-southeast-2.amazonaws.com/assets/creativecommonspp.svg" width={36} preview={false} />
                    </div>
                  </div>
                  <div>
                    {data && data.design && (
                      <Typography.Text>
                        {data.design.name || ""}{" "}
                        {data.design &&
                        data.design.owner &&
                        data.design.owner.firstName
                          ? `by ${data.design.owner.firstName || ""} ${
                              data.design.owner.lastName || ""
                            } `
                          : ""}
                        is licensed under the{" "}
                        <Typography.Link
                          href="https://creativecommons.org/licenses/by/4.0/"
                          target="_blank"
                        >
                          Creative Commons - Attribution
                        </Typography.Link>{" "}
                        license.
                      </Typography.Text>
                    )}
                  </div>
                </LicenseWrapper>
                )}  
              </Col>
              <Col md={18} xs={24}>
                <BoxQ style={{ padding: ".5rem 1rem" }}>
                  <SmallText
                    style={{ paddingTop: "1.5rem", paddingBottom: ".5rem" }}
                  >
                    summary
                  </SmallText>
                  <ExpertText dark>
                    {data?.design?.summary || "No summary added"}
                  </ExpertText>
                </BoxQ>
              </Col>

              <CommentContainer style={{ marginRight: ".5rem", width: "100%" }}>
                <Col span={24} style={{ width: "100%" }}>
                  <hr
                    style={{
                      border: "1px solid #E3E3E3",
                      width: "100%",
                      margin: "2rem 0 2rem 0",
                    }}
                  />
                  <div id="comments">
                    <Comments parent={data?.design} />
                  </div>

                  <ExpertText
                    dark
                    style={{ textAlign: "center", margin: "2rem 0" }}
                  >
                    <a href="/">LOAD ALL COMMENTS</a>{" "}
                  </ExpertText>
                </Col>
              </CommentContainer>
            </Row>
          </Col>
          {/* <Container> */}
          <HeaderTitle dark style={{ marginTop: "4rem", marginLeft: "10%" }}>
            Items You May Like
          </HeaderTitle>
          <Section span={20} offset={2} style={{ width: "100%" }}>
            <Row
              gutter={[32, 32]}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {designsData &&
                designsData.designs.designs.map((s: any) => {
                  return (
                    <Col
                      key={s._id}
                      lg={{ span: 8 }}
                      md={{ span: 12 }}
                      sm={{ span: 24 }}
                      style={{ width: "100%" }}
                    >
                      <MyCard design={s} />
                    </Col>
                  );
                })}
            </Row>
          </Section>
          {/* </Container> */}
        </div>
        <FooterPublic3D />
      </MainWrapper>
    </Spin>
  );
};
export default SingleDesignPage;
